import { marketplaceInviteTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

const collectionState = {
  ...commonState.default({ collection: true }),
  pagination,
};

export const marketplaceInviteList = (state = collectionState, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const marketplaceInviteCreate = (state = defaultState, action) =>
  commonReducer(actionTypes.CREATE, state, action);

export const marketplaceInvitePreview = (state = defaultState, action) =>
  commonReducer(actionTypes.PREVIEW, state, action);
